import { defineComponent as _defineComponent } from 'vue'
import { vShow as _vShow, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted, reactive, useAttrs } from "vue";
  import { BREAKPOINTS, INJECT_STYLES } from "@/utils/swiper";
  
export default /*#__PURE__*/_defineComponent({
  __name: 'Swiper',
  props: {
    slidesPerView: { default: 6 },
    navigation: { type: Boolean, default: true },
    pagination: { type: Boolean, default: false },
    scrollbar: { type: Boolean, default: false },
    mousewheel: { type: Boolean, default: false },
    direction: { default: "horizontal" },
    thumbsSwiper: { default: null },
    spaceBetween: { default: null },
    centeredSlides: { type: Boolean, default: false },
    centeredSlidesBounds: { type: Boolean, default: false },
    checkActiveIndex: { type: Boolean, default: false },
    slideToClickedSlide: { type: Boolean, default: false },
    slidesPerGroup: {},
    type: { default: null },
    breakpointKey: { default: null },
    initialSlide: { default: 0 },
    loop: { type: Boolean, default: false },
    allowTouchMove: { type: Boolean, default: true },
    dynamicBullets: { type: Boolean, default: false },
    dynamicMainBullets: { default: 6 },
    keyboard: { type: Boolean, default: false },
    grid: {},
    freeMode: { type: [Object, Boolean], default: false },
    customEventNavigationButtonsClick: { type: Boolean, default: false },
    speed: { default: 300 }
  },
  emits: ["updateActiveSlideIndex", "swiperInit"],
  setup(__props: any, { emit: __emit }) {

  const emit = __emit;
  const swiper = ref();
  const btnNext = ref<HTMLElement>();
  const btnPrev = ref<HTMLElement>();
  const pagination = ref<HTMLElement>();
  const scrollbar = ref<HTMLElement>();
  const attrs = useAttrs();

  const props = __props;

  const state = reactive({
    activeIndex: 0,
    slides: null as [] | null
  });

  onMounted(() => {
    const swiperEl = swiper;

    if (!swiper.value) {
      console.error("ref swiper is undefined in Swiper.vue component");
      return;
    }

    if (!swiper.value.querySelectorAll) {
      return;
    }
    state.slides = Array.from(swiper.value.querySelectorAll(".swiper-slide"));

    const swiperParams = {
      watchOverflow: true,
      slidesPerView: props.slidesPerView,
      direction: props.direction,
      spaceBetween: props.spaceBetween,
      centeredSlides: props.centeredSlides,
      centeredSlidesBounds: props.centeredSlidesBounds,
      slideToClickedSlide: props.slideToClickedSlide,
      breakpoints: BREAKPOINTS[props.type || props.breakpointKey],
      initialSlide: props.initialSlide,
      loop: props.loop,
      grid: props.grid,
      slidesPerGroup: props.slidesPerGroup,
      allowTouchMove: props.allowTouchMove,
      freeMode: props.freeMode,
      speed: props.speed,
      injectStyles: [INJECT_STYLES],
      navigation: {
        nextEl: btnNext.value,
        prevEl: btnPrev.value
      },
      pagination: {
        el: pagination.value,
        clickable: true,
        dynamicBullets: props.dynamicBullets,
        dynamicMainBullets: props.dynamicMainBullets
      },
      scrollbar: {
        el: scrollbar.value,
        draggable: true
      },
      ...(props.type?.length
        ? {
            containerModifierClass: `swiper-${props.type}-` // bad variable broken swiper styles
          }
        : {}),
      ...(props.keyboard
        ? {
            keyboard: {
              enabled: true
            }
          }
        : {}),
      ...(props.mousewheel
        ? {
            mousewheel: {
              enabled: true
            }
          }
        : {}),
      ...(props.thumbsSwiper
        ? {
            thumbs: {
              swiper: props.thumbsSwiper
            }
          }
        : {}),
      on: {
        afterInit: (sw) => {
          emit("swiperInit", sw);
        }
      }
    };

    Object.assign(swiperEl.value, swiperParams);

    swiperEl.value?.initialize();

    if (props.checkActiveIndex) {
      swiperEl.value?.swiper.on("slideChange", () => {
        updateActiveSlideIndex();
      });
    }

    if (props.customEventNavigationButtonsClick) {
      const swiperData = swiper.value.swiper;
      swiperData.navigation.disable();

      btnNext.value?.addEventListener("click", () => {
        swiper.value?.swiper.slideTo(swiperData.activeIndex + swiperData.params.slidesPerView);
      });

      btnPrev.value?.addEventListener("click", () => {
        swiper.value?.swiper.slideTo(swiperData.activeIndex - swiperData.params.slidesPerView);
      });
    }
  });

  const updateActiveSlideIndex = () => {
    emit("updateActiveSlideIndex", swiper.value?.swiper.activeIndex);
  };

return (_ctx: any,_cache: any) => {
  const _component_swiper_container = _resolveComponent("swiper-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['custom-swiper', { vertical: props.direction === 'vertical' }])
  }, [
    _withDirectives(_createElementVNode("span", {
      class: _normalizeClass(["swiper-navigation-btn swiper-btn-prev", { hidden: !props.navigation }]),
      ref_key: "btnPrev",
      ref: btnPrev
    }, null, 2), [
      [_vShow, props.navigation]
    ]),
    _createVNode(_component_swiper_container, {
      id: _unref(attrs).id ? `swiper-${_unref(attrs).id}` : '',
      class: "swiper-wrapper",
      init: "false",
      ref_key: "swiper",
      ref: swiper
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["id"]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(["swiper-scrollbar", { hidden: !props.scrollbar }]),
      ref_key: "scrollbar",
      ref: scrollbar
    }, null, 2), [
      [_vShow, props.scrollbar]
    ]),
    _withDirectives(_createElementVNode("span", {
      class: _normalizeClass(["swiper-navigation-btn swiper-btn-next", { hidden: !props.navigation }]),
      ref_key: "btnNext",
      ref: btnNext
    }, null, 2), [
      [_vShow, props.navigation]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(['pagination', { hidden: !props.pagination }]),
      ref_key: "pagination",
      ref: pagination
    }, null, 2), [
      [_vShow, props.pagination]
    ])
  ], 2))
}
}

})